import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
import type { SanityRouteDocument } from "@ouster/shared";
import { SanityRichText } from "~/features/sanity/rich-text";
import { SanityMediaFigure } from "~/features/sanity/page-builder/sections/media-figure";
import { Wrap } from "~/features/ui/wrap";
type Props = {
  route: Pick<SanityRouteDocument, "title" | "webinarMetadata">;
};
export function SanityWebinarWatch({
  route
}: Props) {
  const metadata = route.webinarMetadata;
  const watchText = metadata?.watchText;
  if (!metadata?.watchMedia) {
    return null;
  }
  return <_StyledDiv data-sanity-webinar-watch>
      <_StyledWrap>
        <_StyledSection>
          <_StyledDiv2>
            <_StyledHeader>
              <_StyledP>Webinar</_StyledP>
              {route.title && <_StyledH>
                  Watch {route.title}
                </_StyledH>}
            </_StyledHeader>
            <SanityMediaFigure media={metadata.watchMedia} ratio="16/9" showExternalVideoControls sizes="(min-width: 1024px) 1120px, 100vw" />
            {watchText?.length ? <_StyledSanityRichText value={watchText} /> : null}
          </_StyledDiv2>
        </_StyledSection>
      </_StyledWrap>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-17gcyu7-0"
})({
  "minHeight": "100svh",
  "backgroundColor": "var(--bg-secondary)",
  "color": "var(--text-primary)"
});
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-17gcyu7-1"
})({
  "borderWidth": "0px"
});
var _StyledSection = _styled3("section").withConfig({
  componentId: "sc-sf-17gcyu7-2"
})({
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "paddingTop": "8rem",
  "paddingBottom": "8rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem",
    "paddingTop": "12rem",
    "paddingBottom": "12rem"
  }
});
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-17gcyu7-3"
})({
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "maxWidth": "1120px",
  "flexDirection": "column",
  "gap": "3.2rem",
  "@media (min-width: 1024px)": {
    "gap": "4.8rem"
  }
});
var _StyledHeader = _styled5("header").withConfig({
  componentId: "sc-sf-17gcyu7-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.6rem"
});
var _StyledP = _styled6("p").withConfig({
  componentId: "sc-sf-17gcyu7-5"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "textTransform": "uppercase",
  "color": "var(--text-secondary)",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }
});
var _StyledH = _styled7("h1").withConfig({
  componentId: "sc-sf-17gcyu7-6"
})({
  "maxWidth": "920px",
  "fontSize": "2.8rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "5.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.054000000000000006rem",
    "fontWeight": "400"
  }
});
var _StyledSanityRichText = /*#__PURE__*/_styled8(SanityRichText).withConfig({
  displayName: "webinar-watch___StyledSanityRichText",
  componentId: "sc-19gjox6-0"
})({
  "marginLeft": "auto",
  "marginRight": "auto",
  "maxWidth": "840px",
  "color": "var(--text-primary)"
});